import { render, staticRenderFns } from "./PoolDetailsTab.vue?vue&type=template&id=37723ede&scoped=true&"
import script from "./PoolDetailsTab.vue?vue&type=script&lang=js&"
export * from "./PoolDetailsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37723ede",
  null
  
)

export default component.exports